import React, { useEffect, useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      marginLeft: 0,
    },
  },
};

interface AAMultiSelectProps {
  listItems: string[];
  OnSelectChange?: (selectedItems: string[]) => void;
  labelName: string;
  selected?: string[];
}

const AAMultiSelect: React.FC<AAMultiSelectProps> = ({
  listItems,
  OnSelectChange,
  labelName,
  selected = [],
}) => {
  const [selectedItems, setSelectedItems] = useState<string[]>(selected);
  const [itemList] = useState<string[]>(listItems || []);

  useEffect(() => {
    setSelectedItems(selected || []);
  }, [selected]);

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const { value } = event.target;
    setSelectedItems(typeof value === "string" ? value.split(",") : value);
  };

  useEffect(() => {
    if (OnSelectChange) OnSelectChange(selectedItems);
  }, [selectedItems, OnSelectChange]);

  return (
    <div>
      <FormControl sx={{ mt: 0.75, width: 144 }} variant="outlined" size="small">
        <InputLabel id="multiselect-label">{labelName}</InputLabel>
        <Select
          labelId="multiselect-label"
          id="multiselect"
          multiple
          value={selectedItems}
          onChange={handleChange}
          input={<OutlinedInput label={labelName} />}
          renderValue={(selected) => (selected as string[]).join(", ")}
          MenuProps={MenuProps}
          sx={{ height: 40 }}
        >
          {itemList.map((item) => (
            <MenuItem key={item} value={item}>
              <Checkbox checked={selectedItems.indexOf(item) > -1} />
              <ListItemText primary={item} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default AAMultiSelect;
